import { IDataSet, DataSet } from './DataSet';

export interface ICurrentDataSets {
    dataSets: IDataSet[];
    lastEventId: number;
}

export class CurrentDataSets implements ICurrentDataSets {
    public dataSets: DataSet[];
    public lastEventId: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ICurrentDataSets);
    constructor(obj?: any) {
        this.lastEventId = obj && obj.lastEventId || 0;
        this.dataSets = [];
        if (obj && obj.dataSets !== undefined) {
            obj.dataSets.forEach((dataSet: any) => {
                this.dataSets.push(new DataSet(dataSet));
            });
        }
    }
}
